import { ToastContentProps } from 'react-toastify';

import Image from 'next/image';
import Link from 'next/link';

import tickIcon from '@/assets/icons/toast-tick-icon.svg';
import crossIcon from '@/assets/icons/x-close (1).svg';
import useWebAlias from '@/helpers/hooks/useWebalias';
import { useAppContext } from '@/layouts/AppProvider';

import '@/styles/globals.v2.css';

import PseudoLink from '@/components/PseudoLink';

export type BareAddedToEzShip = {
  productName: string;
  ezShipTitle: string;
  ezShipId: string | number;
};
type AddedToCartPopupProps = Omit<ToastContentProps<unknown>, 'toastProps' | 'data'> & BareAddedToEzShip;

const AddedToExistingEzShipPopup: React.FC<AddedToCartPopupProps> = ({
  productName,
  closeToast,
  ezShipTitle,
  ezShipId,
}) => {
  const { generateURL, webalias } = useWebAlias();
  const { isBackOffice } = useAppContext();

  const ezShipDetailURL = isBackOffice
    ? `/AutoOrders/EzShipDetail/${ezShipId}`
    : generateURL(`/auto-order/EzShipDetail/${ezShipId}`, webalias);

  return (
    <div className="v2-relative v2-flex v2-gap-0 sm:v2-gap-4 v2-items-start">
      <Image src={tickIcon} alt="toast-icon" width={40} height={40} className="v2-hidden sm:v2-block" />
      <div className="v2-flex v2-justify-between v2-items-start v2-w-full">
        <div className="v2-px-0">
          <h1 className=" v2-font-sweet-sans-pro-semi-bold v2-font-semibold v2-text-sm v2-text-gray-700 v2-mb-1">
            Product Added to EZ Ship
          </h1>
          <p className="v2-font-sweet-sans-pro v2-text-sm v2-font-normal v2-text-gray-600">
            {productName} has been added to {ezShipTitle}.{' '}
            <Link className="v2-underline" href={ezShipDetailURL} prefetch={false} target="_blank">
              Click here
            </Link>{' '}
            to view your EZ Ship.
          </p>

          <div className="v2-flex v2-gap-2 v2-mt-3">
            <PseudoLink
              onClick={e => closeToast && closeToast()}
              className="v2-text-sm v2-text-gray-600 v2-font-sweet-sans-pro v2-font-medium"
            >
              Dismiss
            </PseudoLink>
            <Link
              onClick={() => closeToast && closeToast()}
              href={ezShipDetailURL}
              className="v2-text-sm v2-font-sweet-sans-pro v2-font-medium v2-text-primary-700"
              prefetch={false}
              target="_blank"
            >
              Details
            </Link>
          </div>
        </div>
        <Image
          src={crossIcon}
          alt="toast-close-icon"
          className="v2-cursor-pointer"
          width={20}
          height={20}
          onClick={closeToast}
        />
      </div>
    </div>
  );
};

export default AddedToExistingEzShipPopup;
